"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tinycolor = require("@ctrl/tinycolor");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Converts a hex color into a rgb color. Setting 'alpha' will return a rgba color.
 * @param {string} hexColor
 * @param {string|number} alpha
 */

var getRgbaFromHex = function getRgbaFromHex(hexColor, alpha) {
  return new _tinycolor.TinyColor(hexColor).setAlpha(alpha).toRgbString();
};
var _default = exports.default = getRgbaFromHex;